<i18n src="../../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <div class="row  mb-1" v-if="el.Text != null && el.Text != ''">
      <div class="col-12">
        {{el.Text}}
      </div>
    </div>
    <div class="row">
      <div class="col-12" v-show="showCalender == true">
        <input-inline-calender class="inline" @changed_month="changedMonth" @changed_date="changedDate" ref="dateSelector"></input-inline-calender>
      </div>
      <div class="container-fluid" v-show="showDates == true">
        <div class="row">
          <div class="col-2 p-0">
            <button @click="prevDate" type="button" class="btn bg-light">
              <
            </button>
          </div>
          <div class="col-8 p-2 text-center">
            {{selectedDateStr}}
          </div>
          <div class="col-2 p-0">
            <button @click="nextDate" type="button" class="btn bg-light">
              >
            </button>
          </div>
        </div>
      </div>
      <div class="mt-1 pr-3" v-show="showDates == true" style="height:200px;overflow-y:scroll;position:relative; width:100%">
        <div v-for="(slot, index) in dayslots" class="" style="display:inline-table;margin:auto;overflow:visible;position:absolute;width:100%" v-bind:style="getContainerStyle(index, slot)">
          <div class="container-fluid p-0">
            <div class="row">
              <div class="col-3" style="height:30px"><span v-if="slot.isHourStart == true">{{slot.time}}</span></div>
              <div @click="unselect(slot)" v-if="slot.selected == true" class="col-9 slot selected" style="cursor:pointer" v-bind:style="getRowStyle(index, slot)">
                selected
              </div>
              <div @click="select(slot)" v-if="slot.available == true" class="col-9 slot success" style="cursor:pointer" v-bind:style="getRowStyle(index, slot)">
                Available
              </div>
              <div v-if="slot.available == false" class="col-9 slot" style="height:15px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-1" v-show="showConfirm == true">
        <div class="row">
          <div class="col-12">

            You are about to book: x-y on date z<br />
            Do you want to proceed?

          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <button @click="cancelBook" type="button" class="btn bg-light">
              cancel
            </button>
          </div>
          <div class="col-6 text-right">
            <button @click="book" type="button" class="btn bg-light">
              Book
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "element-view-booking",
    components: {
      
    },
    props: {
      el: {
        type: Object,
        default: { Elements: [] }
      },
      date: {
        required: false,
        tyrrpe: String,
        default: null
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      assigned: {
        required: false,
        type: String,
        default: null
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },
      visible: {
        required: false,
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        dayslots: [],
        showDates: false,
        showCalender: true,
        selectedDate: null,
        selectedDateStr: '',
        availableslots: [],
        resourceid: '',
        showConfirm : false,
        slotBookingId : 0,
        slot: null,
      };
    },
    methods: {
      getContainerStyle(index, slot) {
        var ret = 'padding-top:' + index * slot.minutes + 'px !important'
        if (slot.selected == true) {
          ret += ';z-index:100';
        }
        else if (slot.available == true)
        {
          ret += ';z-index:75';
        }
        else {
          ret += ';z-index:50';
        }
        return ret
      },
      getRowStyle(index, slot) {
        var ret = ''
        if (slot.minutes) {
          ret += 'height:' + (slot.Minutes) + 'px';
        }
        else {
          ret += 'height:15px;';
        }
        return ret
      },
      unselect(slot) {
        this.slot = slot;
        this.showConfirm = true;
        //alert("Unselect slot with:" + JSON.stringify(slot))
        /*
        try {

          this.$http.get('/api/Booking/CancelBooking?slotbookingid=-1').then(async response => {

            alert("tried to delete booking")

          });
        } catch (err) {
          alert('some error:' + err)
        }

        alert("Unselect slot with:" + JSON.stringify(slot))
        slot.selected = false;
        slot.available = true;
        */
        Vue.set(this, "dayslots", this.dayslots)
        this.$forceUpdate();
      },
      select(slot) {

        /*
        var data = [{
          SlotId: slot.Id,
          BookDate: this.date + " " + slot.time
        }]
        
        alert("sending data:" + JSON.stringify(data));

        try {

          this.$http.post('/api/Booking/AddSlotsBookings', data).then(async response => {

            alert("posted data")

          });
        } catch (err) {
          alert('some error:' + err)
        }
*/
        this.showConfirm = true;
        this.slot = slot;
        slot.selected = true;
        slot.available = false;
        Vue.set(this, "dayslots", this.dayslots)
        this.$forceUpdate();
      },
      book() {
        alert("book, here we might want to show a confirm");
      },
      cancelBook() {
        this.slotBookingId = 0;
        this.slot = null;
        this.showConfirm = false;
        this.showDates = true;
        this.showCalender = false;
      },
      prevDate() {
        this.stepDate(-1);
      },
      nextDate() {
        this.stepDate(1);
      },
      stepDate(step) {
        var mom = new moment(this.selectedDate);
        mom = mom.add(step, "days")
        this.selectedDate = mom.toDate();
        this.date = mom.format("YYYY-MM-DD")
        this.selectedDateStr = mom.format("dddd, MMMM Do YYYY");
        this.loadSlotsForDate();
      },
      changedDate(date) {
        var mom = this.$store.getMomentLocale(date);
        this.selectedDate = date;
        this.date = mom.format("YYYY-MM-DD")
        this.selectedDateStr = mom.format("dddd, MMMM Do YYYY");
        this.showDates = true;
        this.showCalender = false;
        this.loadSlotsForDate();
      },
      changedMonth(date) {
        var mom = this.$store.getMomentLocale(date);
      },
      openUrl(el,val) {
        this.$emit('openUrl', el, val);
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

        if (this.el.Settings != null && this.el.Settings.Property)
        this.resourceid = this.el.Settings.Property["resourceid"];

        this.dayslots = [];
        for (var i = 0; i < 24; i++) {

          for (var k = 0; k < 4; k++) {
            var isHourStart = true;
            if (k > 0)
              isHourStart = false;

            
            var start = i.toString();
            if (start.length < 2)
              start = "0" + start;

            var minuteStart = (k * 15).toString();
            if (minuteStart == "0")
              minuteStart = "00";
            else if (minuteStart == "3")
              minuteStart = "30";

            this.dayslots.push({ isHourStart: isHourStart, time: start + ":" + minuteStart, available: false, minutes: 15, bookingId : 0 })
          }
        }

        this.selectedDate = new Date();
        var mom = this.$store.getMomentLocale(date);
        this.date = mom.format("YYYY-MM-DD")
        this.$refs.dateSelector.initCalender(this.selectedDate)
        
        this.loadAvailabilityForMonth()
      },
      async loadAvailabilityForMonth() {
        try {
          var dates = [];
          var startDate = moment().startOf('month').format('YYYY-MM-DD hh:mm');
          var endDate = moment().endOf('month').format('YYYY-MM-DD hh:mm');

          this.$http.get('/api/Booking/GetResourceAvailbleSlots?resourceid=' + this.resourceid + '&startDate=' + startDate + '&endDate=' + endDate).then(async response => {
            //this.availableslots = [];
            //alert(JSON.stringify(response.data))

            for (var i = 0; i < response.data.length; i++) {
              dates.push({ Summary: "", StartDateString: response.data[i].StartDateString })
            }

            this.$refs.dateSelector.setHighlightDates(this.selectedDate, dates);
            this.$refs.dateSelector.initCalender(this.selectedDate)

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async loadSlotsForDate() {
        try {
          
          var mom = new moment(this.selectedDate);
          var startDate = mom.format("YYYY-MM-DD");
          mom = mom.add(1, "days")
          var endDate = mom.format("YYYY-MM-DD");

          this.$http.get('/api/Booking/GetResourceSlotsDetail?resourceid=' + this.resourceid + '&startDate=' + startDate + '&endDate=' + endDate).then(async response => {
            // reset the dayslots
            for (var i = 0; i < this.dayslots.length; i++) {
              this.dayslots[i].available = false;
              this.dayslots[i].bookingId = 0;
              this.dayslots[i].minutes = 15;
            }
            
            for (var i = 0; i < response.data.length; i++) {
              var slotStart = Date.parse(response.data[i].StartDateString + " " + response.data[i].StartTimeString);
              var slotEnd = Date.parse(response.data[i].EndDateString + " " + response.data[i].EndTimeString);
              
              for (var k = 0; k < this.dayslots.length; k++) {

                var daySlotStart = Date.parse(this.date + " " + this.dayslots[k].time);
                
                if (slotStart <= daySlotStart && daySlotStart < slotEnd) {
                  this.dayslots[k].id = response.data[i].Id;
                  this.dayslots[k].minutes = response.data[i].SlotLength;
                  this.dayslots[k].bookingId = response.data[i].BookingId;
                  this.dayslots[k].available = response.data[i].BookingId == 0;
                  this.dayslots[k].selected = response.data[i].BookingId > 0;
                }
              }
            }

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },

    },
    computed: {
      elements: {
        get() {
          return this.el.Elements;
        }
      }
    },
    watch: {
     
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>

  .slot{
    border-top: 1px solid #f7f7f7;
  }

  .slot.success {
    background-color: #25b372 !important;
    border: 2px #25b372 solid !important;
  }
  .slot.selected {
    background-color: #25b372 !important;
    border: 2px #0a6a3e solid !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-viewing-elements/element-view-booking.vue